__turbopack_context__.v({
  "banner": "Banner-module-scss-module__GVy0HG__banner",
  "cta": "Banner-module-scss-module__GVy0HG__cta",
  "cta-large-button": "Banner-module-scss-module__GVy0HG__cta-large-button",
  "dismiss-button": "Banner-module-scss-module__GVy0HG__dismiss-button",
  "flex-end": "Banner-module-scss-module__GVy0HG__flex-end",
  "highlight-wrapper": "Banner-module-scss-module__GVy0HG__highlight-wrapper",
  "icon": "Banner-module-scss-module__GVy0HG__icon",
  "illustration": "Banner-module-scss-module__GVy0HG__illustration",
  "info": "Banner-module-scss-module__GVy0HG__info",
  "info-icon": "Banner-module-scss-module__GVy0HG__info-icon",
  "promo": "Banner-module-scss-module__GVy0HG__promo",
  "title": "Banner-module-scss-module__GVy0HG__title",
  "title-and-large-cta-wrapper": "Banner-module-scss-module__GVy0HG__title-and-large-cta-wrapper",
  "title-text": "Banner-module-scss-module__GVy0HG__title-text",
  "warning": "Banner-module-scss-module__GVy0HG__warning",
});
